import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { cx } from "../../../../../ui/components/cx";
import "./RichTextEditor.scss";

interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  invalid?: boolean;
}

const QUILL_FORMATS = [
  "font",
  "script",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "color",
  "background",
  "link",
];

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder,
  invalid = false,
}) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ font: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link"],
      ],
    }),
    []
  );

  const handleChange = (content: string) => {
    onChange(content);
  };

  return (
    <div className={cx("tp-rte", invalid && "tp-rte--invalid")}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={handleChange}
        modules={modules}
        formats={QUILL_FORMATS}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
